// function to return the weekday of a localized date time
// date should be in UTC
// format values are ['narrow','short','long']
const weekday = (date, format) => {
  const dtf = new Intl.DateTimeFormat('en-us', {weekday: format});
  return datePart(date, dtf, 'weekday');
};
const datePart = (date, formatter, key) => (
  formatter.formatToParts(date).find(part => part.type === key).value
);

export default { weekday };
